import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMaxToe1 = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 71.955,
	height: 33.802,
	viewBox: "0 0 71.955 33.802",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsxs("g", {
		id: "Group_209",
		"data-name": "Group 209",
		transform: "translate(0)",
		children: [
			/* @__PURE__ */ _jsx("g", {
				id: "Group_203",
				"data-name": "Group 203",
				transform: "translate(0)",
				opacity: 0,
				children: /* @__PURE__ */ _jsx("path", {
					id: "Path_400",
					"data-name": "Path 400",
					d: "M1372.224,591.362H1300.27v-33.8h71.955Zm-71.435-.52H1371.7V558.08H1300.79Z",
					transform: "translate(-1300.27 -557.56)",
					fill: "#040505"
				})
			}),
			/* @__PURE__ */ _jsxs("g", {
				id: "Group_208",
				"data-name": "Group 208",
				transform: "translate(20.408 0.618)",
				children: [
					/* @__PURE__ */ _jsx("g", {
						id: "Group_204",
						"data-name": "Group 204",
						transform: "translate(1.647 0)",
						children: /* @__PURE__ */ _jsx("path", {
							id: "Path_401",
							"data-name": "Path 401",
							d: "M1367.686,576.061c-.343-.178-.74-.375-1.164-.587a22.6,22.6,0,0,1-4.552-2.668c-1.087-1.175-3.678-4.781-4.742-6.277a1.233,1.233,0,0,0-.579-.44c.064-.236.139-.483.24-.749.455-1.206,1.4-3.643,1.926-5a1.039,1.039,0,0,0-.592-1.344h0a1.04,1.04,0,0,0-1.346.592c-.529,1.362-1.477,3.809-1.933,5.019a9.3,9.3,0,0,0-.632,3.033l-.083.083a3.277,3.277,0,0,1-1.921-.465,4.254,4.254,0,0,1-1.123-1.328c-.022-.04-.055-.073-.08-.111.195-.326.426-.742.731-1.291a14.794,14.794,0,0,0,1.417-4.532,1.039,1.039,0,1,0-2.036-.416,13.045,13.045,0,0,1-1.2,3.94c-.4.713-.634,1.119-.773,1.349a2.1,2.1,0,0,0-1.245.483,10.355,10.355,0,0,0-1.36,1.4,18.85,18.85,0,0,0-2.008,2.983c-.228.1-.618.385-1.676,1.619a1.04,1.04,0,0,0-.215.95,6.469,6.469,0,0,0,3.651,3.736c2.625,1.271,11.473,4.5,11.892,4.65.194.061,4.768,1.48,7.8.466l.1-.034c1.631-.573,2.657-1.645,2.753-2.882A2.242,2.242,0,0,0,1367.686,576.061ZM1349.665,564.8a1.015,1.015,0,0,1,.195-.017A1.048,1.048,0,0,0,1349.665,564.8Zm-.036.009a1.064,1.064,0,0,0-.139.04l.017-.008A.992.992,0,0,1,1349.629,564.812Zm17.233,13.27c-.02.258-.413.77-1.438,1.1-1.982.663-5.374-.12-6.47-.463-.092-.033-9.124-3.328-11.655-4.553a5.379,5.379,0,0,1-2.327-1.956c.241-.264.458-.49.579-.6l.147-.049a1.045,1.045,0,0,0,.617-.555,15.567,15.567,0,0,1,1.937-2.946,7.2,7.2,0,0,1,1.1-1.124c.015,0,.018.009.019.011a6.163,6.163,0,0,0,1.713,1.987,5.681,5.681,0,0,0,4,.784,1.043,1.043,0,0,0,.739-.546c.1-.19.213-.39.326-.572,1.381,1.926,3.316,4.562,4.285,5.61.871.941,2.764,1.926,5.149,3.116.414.206.8.4,1.136.573C1366.869,577.979,1366.864,578.043,1366.862,578.082Z",
							transform: "translate(-1342.706 -558.748)",
							fill: "#040505"
						})
					}),
					/* @__PURE__ */ _jsx("g", {
						id: "Group_205",
						"data-name": "Group 205",
						transform: "translate(25.941 30.44)",
						children: /* @__PURE__ */ _jsx("path", {
							id: "Path_402",
							"data-name": "Path 402",
							d: "M1393.61,617.32h-3.063a1.078,1.078,0,0,0-1.081.865,1.04,1.04,0,0,0,1.025,1.214h3.063a1.078,1.078,0,0,0,1.081-.865A1.04,1.04,0,0,0,1393.61,617.32Z",
							transform: "translate(-1389.452 -617.32)",
							fill: "#040505"
						})
					}),
					/* @__PURE__ */ _jsx("g", {
						id: "Group_206",
						"data-name": "Group 206",
						transform: "translate(10.726 30.44)",
						children: /* @__PURE__ */ _jsx("path", {
							id: "Path_403",
							"data-name": "Path 403",
							d: "M1368.823,617.32h-7.552a1.077,1.077,0,0,0-1.081.865,1.04,1.04,0,0,0,1.025,1.214h7.552a1.079,1.079,0,0,0,1.081-.865A1.04,1.04,0,0,0,1368.823,617.32Z",
							transform: "translate(-1360.175 -617.32)",
							fill: "#040505"
						})
					}),
					/* @__PURE__ */ _jsx("g", {
						id: "Group_207",
						"data-name": "Group 207",
						transform: "translate(0 30.44)",
						children: /* @__PURE__ */ _jsx("path", {
							id: "Path_404",
							"data-name": "Path 404",
							d: "M1343.7,617.32h-3.062a1.078,1.078,0,0,0-1.081.865,1.04,1.04,0,0,0,1.025,1.214h3.062a1.078,1.078,0,0,0,1.081-.865A1.04,1.04,0,0,0,1343.7,617.32Z",
							transform: "translate(-1339.537 -617.32)",
							fill: "#040505"
						})
					})
				]
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_405",
				"data-name": "Path 405",
				d: "M1395.517,602.746l-.994.994v-2.9l.994.994a1.039,1.039,0,0,0,1.47-1.47l-2.768-2.767a1.039,1.039,0,0,0-1.47,0l-2.768,2.767a1.039,1.039,0,1,0,1.47,1.47l.994-.993v2.9l-.994-.994a1.039,1.039,0,0,0-1.47,1.47l2.768,2.768a1.04,1.04,0,0,0,1.47,0l2.768-2.768a1.039,1.039,0,0,0-1.47-1.47Z",
				transform: "translate(-1343.211 -576.645)",
				fill: "#040505"
			})
		]
	})]
});
const ForwardRef = forwardRef(SvgMaxToe1);
export { ForwardRef as ReactComponent };
